var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReviewAgentFetched(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 28 28",
    style: {
      enableBackground: "new 0 0 28 28"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#8D9298;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,8.7c-0.1-0.1-0.2-0.1-0.2-0.2c-0.1,0-0.2-0.1-0.3-0.1s-0.2,0-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.2l-1,1V5.6 c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.2c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.2,0.3-0.2,0.5v4.2l-1-1 c-0.1-0.1-0.2-0.1-0.2-0.2S21,8.5,20.9,8.5c-0.2,0-0.4,0.1-0.5,0.2c-0.1,0.1-0.1,0.2-0.2,0.2c0,0.1-0.1,0.2-0.1,0.3 c0,0.2,0.1,0.4,0.2,0.5l2.2,2.2c0.1,0.1,0.2,0.1,0.2,0.2c0.1,0,0.2,0.1,0.3,0.1s0.2,0,0.3-0.1c0.1,0,0.2-0.1,0.2-0.2l2.2-2.2 C25.9,9.7,26,9.7,26,9.6c0-0.1,0.1-0.2,0.1-0.3c0-0.1,0-0.2-0.1-0.3C26,8.9,25.9,8.8,25.9,8.7z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M10.5,14c-0.3,0-0.6,0.1-0.8,0.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3 s0.6-0.1,0.8-0.3c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8C11.1,14.1,10.8,14,10.5,14z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M14,5.7c2.1,0,3.9,0.7,5.4,2.1l0.7,0.7c0,0,0.7-0.7,1.3-0.1l0.6,0.6V7.4c-0.3-0.4-0.8-0.9-1.2-1.2 c-0.9-0.8-2-1.5-3.2-1.9c-1.2-0.5-2.4-0.7-3.8-0.7s-2.6,0.2-3.8,0.7C9,4.7,8,5.3,7,6.2C6.1,7,5.3,8,4.7,9.1c-0.6,1.1-1,2.4-1.1,3.7 l-0.1,1.5c-0.4,0.2-0.7,0.5-0.9,0.9s-0.3,0.8-0.3,1.2v2.3c0,0.6,0.2,1.2,0.7,1.7C3.5,20.8,4,21,4.7,21h1.2v-7.1 c0-2.3,0.8-4.2,2.4-5.8C9.8,6.5,11.7,5.7,14,5.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,11.4c1.5,0.9,3.1,1.4,4.9,1.4c-0.3-1.7-1.1-3.1-2.4-4.2C17.3,7.5,15.8,7,14.1,7C12,7,10.3,7.7,8.9,9.2 c-1.4,1.5-2,3.3-1.9,5.3c1.5-0.6,2.7-1.5,3.7-2.7c1-1.2,1.7-2.6,2-4.2C13.5,9.2,14.6,10.5,16.1,11.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.4,15c-0.2-0.3-0.5-0.6-0.9-0.8l-0.1-1.5c0-0.3-0.1-0.6-0.2-1l-0.4,0.4c-0.1,0.1-0.2,0.2-0.3,0.2 s-0.3,0.1-0.4,0.1s-0.3,0-0.4-0.1c-0.1,0-0.2-0.1-0.3-0.2l-0.5-0.5c0.2,0.7,0.3,1.4,0.3,2.2v8.3h-9.3v2.3h9.3 c0.6,0,1.2-0.2,1.6-0.7c0.5-0.5,0.7-1,0.7-1.7v-1.4c0.4-0.2,0.7-0.4,0.9-0.8c0.2-0.4,0.3-0.7,0.3-1.1v-2.7 C25.7,15.8,25.6,15.4,25.4,15z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.7,14.3c-0.2,0.2-0.3,0.5-0.3,0.8c0,0.3,0.1,0.6,0.3,0.8c0.2,0.2,0.5,0.3,0.8,0.3s0.6-0.1,0.8-0.3 c0.2-0.2,0.3-0.5,0.3-0.8c0-0.3-0.1-0.6-0.3-0.8c-0.2-0.2-0.5-0.3-0.8-0.3S16.9,14.1,16.7,14.3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReviewAgentFetched);
export default __webpack_public_path__ + "static/media/reviewAgentFetched.2b82db0c.svg";
export { ForwardRef as ReactComponent };